import "@total-typescript/ts-reset";
import { setSentry } from "@mozioinc/logging";
import { captureException } from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import "./index.css";
import { GeneralError } from "./components";
import { handleAuthCheck } from "./utils/auth";
import { getEnvs } from "./utils/env";
import { setLoggly } from "./utils/logging";
import { setOsano } from "./utils/osano";
import { setTranslation } from "./utils/translation";
import { setWhiteLabel } from "./utils/white-label";

const {
  VERCEL_GIT_COMMIT_SHA,
  VERCEL_GIT_PREVIOUS_SHA,
  VERCEL_ENV,
  MOZIO_PUBLIC_SENTRY_DSN,
} = getEnvs();
window.APP_VERSION = `${BUILD_DATE}-${VERCEL_GIT_COMMIT_SHA?.slice(0, 7)}`;
window.GIT_COMMIT_SHA = VERCEL_GIT_COMMIT_SHA;
window.GIT_PREVIOUS_SHA = VERCEL_GIT_PREVIOUS_SHA;

setSentry({
  env: VERCEL_ENV,
  version: window.APP_VERSION,
  dsn: MOZIO_PUBLIC_SENTRY_DSN,
});

Promise.resolve()
  .then(setWhiteLabel)
  .then(setOsano)
  .then(handleAuthCheck)
  .then(setTranslation)
  // setLoggly() must happen after setWhiteLabel() because it reads from white label. This is only required for dev mode.
  .then(setLoggly)
  .then(() =>
    ReactDOM.createRoot(document.querySelector("#root") as HTMLElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    ),
  )
  .catch((error: Error) => {
    console.error(error);
    captureException(error);
    ReactDOM.createRoot(document.querySelector("#root") as HTMLElement).render(
      <React.StrictMode>
        <GeneralError className="min-h-screen" />
      </React.StrictMode>,
    );
  });
